import React, { ReactElement } from "react";
import { Table } from "antd";
import { rowClassName } from "..";
import { ProductSummaryRecord } from "../../../redux/types/reportTypes";
import "./index.scss";

export const columns = [
  {
    title: "Product",
    dataIndex: "product",
  },
  {
    title: "UP WTD",
    dataIndex: "up_wtd",
  },
  {
    title: "DOWN WTD",
    dataIndex: "down_wtd",
  },
  {
    title: "NEUT WTD",
    dataIndex: "neutral_wtd",
  },
  {
    title: "WTD ADS",
    dataIndex: "wtd_ads",
  },
  {
    title: "WTD DIFF",
    dataIndex: "wtd_diff",
  },
  {
    title: "WTD % DIFF",
    dataIndex: "wtd_perc_diff",
  },
  {
    title: "UP MTD",
    dataIndex: "up_mtd",
  },
  {
    title: "DOWN MTD",
    dataIndex: "down_mtd",
  },
  {
    title: "NEUT MTD",
    dataIndex: "neutral_mtd",
  },
  {
    title: "MTD ADS",
    dataIndex: "mtd_ads",
  },
  {
    title: "MTD DIFF",
    dataIndex: "mtd_diff",
  },
  {
    title: "MTD % DIFF",
    dataIndex: "mtd_perc_diff",
  },
  {
    title: "UP QTD",
    dataIndex: "up_qtd",
  },
  {
    title: "DOWN QTD",
    dataIndex: "down_qtd",
  },
  {
    title: "NEUT QTD",
    dataIndex: "neutral_qtd",
  },
  {
    title: "QTD ADS",
    dataIndex: "qtd_ads",
  },
  {
    title: "QTD DIFF",
    dataIndex: "qtd_diff",
  },
  {
    title: "QTD % DIFF",
    dataIndex: "qtd_perc_diff",
  },
];

type ProductTableProps = {
  loading: boolean;
  records: Array<ProductSummaryRecord>;
};

type Keys =
  | "up_wtd"
  | "down_wtd"
  | "neutral_wtd"
  | "wtd_ads"
  | "wtd_diff"
  | "wtd_perc_diff"
  | "up_mtd"
  | "down_mtd"
  | "neutral_mtd"
  | "mtd_ads"
  | "mtd_diff"
  | "mtd_perc_diff"
  | "up_qtd"
  | "down_qtd"
  | "neutral_qtd"
  | "qtd_ads"
  | "qtd_diff"
  | "qtd_perc_diff";

const ProductTable = ({ loading, records }: ProductTableProps): ReactElement => {
  const sum = (key: Keys) =>
    records.reduce((a, b) => a + (parseFloat(String(b[key])) || 0), 0);

  const calculateResultRow = () => {
    const result: ProductSummaryRecord = {
      product: "",
      up_wtd: 0,
      down_wtd: 0,
      neutral_wtd: 0,
      wtd_ads: 0,
      wtd_diff: 0,
      wtd_perc_diff: 0,
      up_mtd: 0,
      down_mtd: 0,
      neutral_mtd: 0,
      mtd_ads: 0,
      mtd_diff: 0,
      mtd_perc_diff: 0,
      up_qtd: 0,
      down_qtd: 0,
      neutral_qtd: 0,
      qtd_ads: 0,
      qtd_diff: 0,
      qtd_perc_diff: 0,
    };

    Object.keys(records[0]).forEach((key) => {
      if (key !== "product") {
        const newKey = key as Keys;
        result[newKey] = sum(newKey);
      }
    });

    return result;
  };

  const totalRecords = () => {
    const newRecords = [...records];
    if (newRecords.length) newRecords.push(calculateResultRow());
    return newRecords;
  };

  return (
    <Table
      className="product-table"
      dataSource={totalRecords()}
      columns={columns}
      loading={loading}
      rowKey="product"
      pagination={false}
      scroll={{ y: 250 }}
      size="small"
      rowClassName={rowClassName}
    />
  );
};

export default ProductTable;
